import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import FilterListIcon from '@mui/icons-material/FilterList';
import { IconButton, Tooltip } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Actions } from '../../Action';
import { bindActionCreators } from 'redux';
import Select from 'react-select';
import "./CmSearchSuggestionsPage.Styles.css";
import Checkbox from '@mui/material/Checkbox';
import { AutoComplete } from 'antd';
import { fetchUsers } from '../../API/api';
import DebounceSelect from './DebounceSelect';
import VizButton from '../../Component/VizButtons/VizButton';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import VizHeader from '../../Component/VizHeader/VizHeader';
import VizParagraph from '../../Component/VizParagraph/VizParagraph';
import {Grid} from "@mui/material";
import MultiSelect from '../../Component/MultiSelect/MultiSelect';
import {filterDomainsForComponent2} from "../../utils";
import MultiSelectCmSearchSuggestions from '../../Component/MultiSelectCmSearchSuggestions/MultiSelectCmSearchSuggestions';




const Accordion = styled((props) => (
<MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function DrawerComponent() {
  const userState = useSelector((state) => state.user);
  const state2 = useSelector(state=>state.cmRoot);
  const [domainValue, setDomainValue] = React.useState("");
  const dispatch = useDispatch();
  const { getQuestionsSubmittedData,bestResultsToggleCM,genAIAnswerToggleCM,getSourceFilterInSearchSuggestions, getDislikesInSearchSuggestions,showEmptySuggestionsContent, getSourceFilterForFromDate, getSourceFilterForTillDate, getAcceptedQuestionFilter,getSearchFilterForEmailFilter,getSeekerFilterInSearchSuggestions,getSeekerFilterInfoInSearchSuggestions,getExpertFilterInSearchSuggestions,getExpertFilterInfoInSearchSuggestions,getDomainNameInSearchSuggestions,updatePageNoInSearchSuggestions,cmRootUpdateDomainVal} = bindActionCreators(Actions, dispatch);
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false)
  const searchSuggestionsReducer = useSelector((state)=>state.searchSuggestionsCM);
  const [source, setSource] = React.useState(searchSuggestionsReducer.source);
  const [domainName, setDomainName] = React.useState(state2.selectedDomainsObj);
  const [fromChecked, setFormChecked] = React.useState(searchSuggestionsReducer.fromDate !== '' ? true: false);
  const [toChecked, setToChecked] = React.useState(searchSuggestionsReducer.tillDate !== '' ? true: false);
  const [isAccepted, setIsAccepted] = React.useState(searchSuggestionsReducer.isAccepted === true ? true : false);
  const [isExcludeEmail, setIsExcludeEmail] = React.useState((searchSuggestionsReducer.excludeEmail === false) || (source === 'email') ? true : false );
  const [getEmptySuggestions, setEmptySuggestions] = React.useState(searchSuggestionsReducer.isEmpty ? true : false);
  const [getDislikes, setDislikes] = React.useState(searchSuggestionsReducer.getDislikes ? true : false)
  const [getFromDate, setFromDate] = React.useState( searchSuggestionsReducer.fromDate || "");
  const [getTillDate, setTillDate] = React.useState(searchSuggestionsReducer.tillDate || "");
  const [inputValue, setInputValue] = React.useState("");
  const [domainsIds,setDomainIds] = React.useState([]);
  const [options,setOptions] = React.useState([]);
  const [anotherOptions,setAnotherOptions] = React.useState([]);
  const[option,setSelectedOption] = React.useState('');
  const [value, setValue] = React.useState([]);
  const [getFetchedUsers, setFetchedUsers] = React.useState(searchSuggestionsReducer.seekersListInfo.length > 0 ?searchSuggestionsReducer.seekersListInfo :[]);
  const [getFetchedUsersExperts,setFetchedUsersExperts] = React.useState(searchSuggestionsReducer.expertsListInfo.length > 0 ? searchSuggestionsReducer.expertsListInfo : []);
  const [roleType, setRoleType] = React.useState('');
  const [getUserData, setUserData] = React.useState([]);
  const [getUserDataExpert, setUserDataExpert] = React.useState([]);
  const [inputSeeker, setInputSeeker] = React.useState('');
  const [inputExpert,setInputExpert] = React.useState('');
  var now = new Date();
	var minDate = now.toISOString().substring(0, 10);
  const [genAIAnswer, setGenAIAnswer] = React.useState(searchSuggestionsReducer.genAIToggle ? true : false);
  const [getBestResults, setBestResults] = React.useState(searchSuggestionsReducer.bestResultToggle ? true : false);
  const [getQSubmitted, setQSubmitted] = React.useState(searchSuggestionsReducer.qSubmitted ? true : false);


  const onChangeGetSourcetype = (e, anchor) => {
    setSource(e.target.value);
    // toggleDrawer(anchor, true)
    if (e.target.value === 'allsource') {
      getSourceFilterInSearchSuggestions('')
    }
    if(e.target.value === 'email')
    {
      setIsExcludeEmail(true)
    }
  }
  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };


  let output = Object.keys(userState.questionAllowedSources !== '' && userState.questionAllowedSources).map((k) => userState.questionAllowedSources[k]);

  let output2 = Object.keys(userState.cmTopics !== undefined && userState.cmTopics).map((k) => userState.cmTopics[k]);
  var newOutput = output2.map((dom, i) => { return { value: dom, label: dom, index: i } })


  const onChangeDomain = (value) => {
      // var domains = [];
    setDomainName(value)
    // value.map((data, ind) => {
    //   domains.push(data.index);
    // })
    // setDomainIds(domains);
  }

  const onChangeFromDate = (e) => {
    setFromDate(e.target.value);
  }


  const onChangeTillDate = (e) => {
    setTillDate(e.target.value);
  }

  const onChangeAccepted = (e) => {
    if (e.target.checked === true) {
      setIsAccepted(true);
    }
    else {
      setIsAccepted(false)
    }
  }


  const onChangeExcludeMail = (e) => {
    if (e.target.checked === true) {
      // setIsAccepted(true);
      setIsExcludeEmail(true);
    }
    else {
      setIsExcludeEmail(false);
    }
  }

  const onChangeInputValue = (data) => {
    setInputValue(data);
    if (data.length > 3) {
      fetchUsers(inputValue, "", "seeker").then((res) => {
        if (res===undefined) return;
        if (res.data.data !== undefined || res.data.success) {
          let newArr = [];
          // setOptions(data ? res.data.data.users : []);
          newArr = res.data.data.users.map((da) => ({
            label: `${da.firstName} ${da.lastName}`,
            value: da.userUuid,
            email: da.email
          }))
          setAnotherOptions(newArr);
        }
      })
    }
  }

  const onChangeDislikes = (e) => {
    if(e.target.checked)
    {
    setDislikes(true)
    }
    else 
    {
      setDislikes(false)
    }
  }

  const onChangeQSubmitted = (e) => {
    if(e.target.checked === true)
    {
      setQSubmitted(true)
    }
    else 
    {
      setQSubmitted(false)
    }
  }

  const onSubmitValues = () => {
    updatePageNoInSearchSuggestions(0)
    if (source !== '') {
      getSourceFilterInSearchSuggestions(source);
    }
    // if (domainsIds.length > 0) {
    //   getSourceFilterForDomains(domainsIds.toString());
    //   getDomainNameInSearchSuggestions(domainName);
    // }
    if(domainName.length === 0)
    {
      cmRootUpdateDomainVal([])
    }
    if(domainName.length > 0)
    {
      cmRootUpdateDomainVal(domainName)
    }
    if (getFromDate !== '') {
      getSourceFilterForFromDate(getFromDate);
    }
    if (getTillDate !== '') {
      getSourceFilterForTillDate(getTillDate);
    }
    getAcceptedQuestionFilter(isAccepted);
    getSearchFilterForEmailFilter(!isExcludeEmail);
    let seekerArray = getFetchedUsers.map((data)=>{
      return data.userUuid.toString()
    })
    getSeekerFilterInSearchSuggestions(seekerArray)
    getSeekerFilterInfoInSearchSuggestions(getFetchedUsers)
    let expertArray = getFetchedUsersExperts.map((data)=>{
      return data.userUuid.toString()
    })
    getExpertFilterInSearchSuggestions(expertArray)
    getExpertFilterInfoInSearchSuggestions(getFetchedUsersExperts)
    if(fromChecked === false && searchSuggestionsReducer.fromDate !== '')
    {
      getSourceFilterForFromDate('')
    }
    if(toChecked === false && searchSuggestionsReducer.tillDate !== '')
    {
      getSourceFilterForTillDate('')
    }
    showEmptySuggestionsContent(getEmptySuggestions);
    getDislikesInSearchSuggestions(getDislikes)
    genAIAnswerToggleCM(genAIAnswer)
    bestResultsToggleCM(getBestResults)
    getQuestionsSubmittedData(getQSubmitted)
  }

  const onChangeFetchUsers = (e,role) => {
    setInputSeeker(e.target.value)
    setRoleType(role);
    if (e.target.value.length > 3 && role === 'Seeker') {
      fetchUsers(e.target.value, "", "seeker").then((res) => {
        if (res===undefined) return;
        if (res.data.success === true || res.data.data !== undefined) {
          let filtered = res.data.data.users.filter(function (obj) {
            let found = false;
            getFetchedUsers.filter((obj2) => {
              if (obj2.userUuid === obj.userUuid || obj2.userUuidStr === obj.userUuid) {
                found = true;
              }
            });
            if (found === false) {
              return obj;
            }
          });
          setUserData(filtered)
        }
      }).catch((err) => { })
    }
  }

  const onChangeFetchUsersExperts = (e) => {
    setInputExpert(e.target.value);
    if (e.target.value.length > 3) {
      fetchUsers(e.target.value, "", "expert").then((res) => {
        if (res===undefined) return;
        if (res.data.success === true || res.data.data !== undefined) {
          let filtered = res.data.data.users.filter(function (obj) {
            let found = false;
            getFetchedUsersExperts.filter((obj2) => {
              if (obj2.userUuid === obj.userUuid || obj2.userUuidStr === obj.userUuid) {
                found = true;
              }
            });
            if (found === false) {
              return obj;
            }
          });
          setUserDataExpert(filtered)
        }
      }).catch((err) => { })
    }

  }

 

  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const onClickGetUserData = (data) => {
    if (roleType === 'Seeker') {
      setFetchedUsers(prev => [...prev, data]);
      setUserData([])
      setInputSeeker('')
    }
  }

  const onClickGetUserExpert = (data) => {
      setFetchedUsersExperts(prev => [...prev, data])
      setUserDataExpert([])
      setInputExpert('')
  }

 const onClickRemoveUsers = (data) => {
  let filteredData = getFetchedUsers.filter((obj) => {
    if(obj.userUuid === undefined){
      if (obj.userUuidStr !== data) {
        return obj;
      }
    }else{
      if (obj.userUuid !== data) {
        return obj;
      }
    }
  });
  setFetchedUsers(filteredData)
  // setUserData(filteredData);
 }

  const onClickRemoveUsersExperts = (data) => {
    let filteredData = getFetchedUsersExperts.filter((obj) => {
      if (obj.userUuid === undefined) {
        if (obj.userUuidStr !== data) {
          return obj;
        }
      } else {
        if (obj.userUuid !== data) {
          return obj;
        }
      }
    });
    setFetchedUsersExperts(filteredData)
    // setUserData(filteredData);
  }

  const onClickCancel = () => {
    setIsDrawerOpen(false)
    setInputSeeker('')
    setInputExpert('')
  }

  const onChangeCheckBoxLastUpdatedFrom = (e) =>{
    setFormChecked(!fromChecked)
    if(fromChecked)
    {
      setFromDate('')
    }
  }

  const onChangeCheckBoxLastUpdatedTill = (e) =>{
    setToChecked(!toChecked)
    if(toChecked)
    {
      setTillDate('')
    }
  }

  const onChangeEmptySuggestions = (e) => {
    if (e.target.checked === true) {
      // setIsAccepted(true);
      setEmptySuggestions(true);
    }
    else {
      setEmptySuggestions(false);
    }
  }

  const onChangeGenAIAnswer = (e) => {
    if (e.target.checked === true) {
      setGenAIAnswer(true)
    }
    else {
      setGenAIAnswer(false)
    }
  }

  const onChangeBestResults = (e) => {
    if (e.target.checked === true) {
      setBestResults(true)
    }
    else {
      setBestResults(false)
    }
  }
  const list = (anchor) => (
    <>
      <Box
        sx={{fontSize: '14px', width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
        role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
      >
        <List>
          <ListItem sx={{paddingTop:1,paddingBottom:0}}>
            <ListItemButton sx={{cursor:'default',paddingTop:0,paddingBottom:0}}>
        <Typography sx={{fontWeight:'bold',paddingTop:'8px'}}>
          <FilterListIcon sx={{marginRight:'5px'}} />Filter
        </Typography>
        </ListItemButton>
        </ListItem>
        </List>
        {/* <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
          <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
            <Typography>Collapsible Group Item #1</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            Source:
              <select value={source} onChange={(e) => onChangeGetSourcetype(e, anchor)}>
                <option value='allsource'>All Source</option>
                {
                  output.map((data, ind) => {
                    return (
                      <option value={data} key={ind} >
                        {data}
                      </option>
                    )
                  })
                }
              </select>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
          <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
            <Typography>Collapsible Group Item #2</Typography>
          </AccordionSummary>
          <AccordionDetails>
          <Typography>
          <p style={{fontSize:'14px'}}>Select Domains</p>
              <Select
                defaultValue={newOutput[0]}
                isMulti
                name="domains"
                options={newOutput}
                className="basicMultiSelect"
                classNamePrefix="select"
                styles={{ fontSize: '12px' }}
                onChange={onChangeDomain}
                value={domainName}
              />
          
          </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
          <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
          <Typography>Collapsible Group Item #3</Typography>
          </AccordionSummary>
          <Typography>
          <div>
                <Checkbox size='small' checked={fromChecked} onChange={(e) => setFormChecked(!fromChecked)} />
                <label>Last Updated From</label>
              </div>
              <input onChange={(e) => onChangeFromDate(e)} placeholder='Last Updated From' disabled={fromChecked === false ? true : false} type="date">
              </input>
              <div>
                <Checkbox size='small' checked={toChecked} onChange={(e) => setToChecked(!toChecked)} />
                <label>Last Updated Till</label>
              </div>
              <input onChange={(e) => onChangeTillDate(e)} disabled={toChecked === false ? true : false} type="date"></input>
          </Typography>
        </Accordion>
        <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
          <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
          <Typography>Collapsible Group Item #4</Typography>
          </AccordionSummary>
          <Typography>
          <Checkbox size='small' checked={isAccepted} onChange={(e) => onChangeAccepted(e)} />
              <label>Accepted Only</label>
              <Checkbox size='small' checked={isExcludeEmail} onChange={(e) => onChangeExcludeMail(e)} />
              <label>Exclude Email Questions</label>
          </Typography>
        </Accordion>
        <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
          <AccordionSummary aria-controls="panel5d-content" id="panel5d-header">
          <Typography>Collapsible Group Item #5</Typography>
          </AccordionSummary>
          <Typography>
          <div style={{padding:'8px 16px',width:'100%',display:'flex',alignItems:'baseline'}}>
              <label>Seeker:</label>
              {/* <DebounceSelect mode="multiple"
                value={value}
                placeholder="Enter Seekers name or email address"
                fetchOptions={fetchUserList}
                onChange={(newValue) => {
                  setValue(newValue);
                }}
                style={{
                  width: '100%',
                  margin:'2px'
                }} /> */}
                 {/* <input style={{fontSize:'14px'}} type="text" onChange={(e)=>onChangeFetchUsers(e)} className='form-control' placeholder='Enter Seekers name or email address'>
                </input> */}
                {/* </div> */}
                {/* <label>Experts:</label> */}
              {/* <input style={{ fontSize: '12px', width: '80%', padding: '5px' }} placeholder='Enter Experts name or email address' type="text"></input> */}
          {/* </Typography> */}
        {/* </Accordion> */}
        {/* Domain code comment */}
                  {/* <Select
                defaultValue={newOutput[0]}
                isMulti
                name="domains"
                options={newOutput}
                className="basicMultiSelect"
                classNamePrefix="select"
                styles={{ fontSize: '12px' }}
                onChange={onChangeDomain}
                value={domainName}
              /> */}
        {/* Domain code comment end */}
        <List sx={{paddingTop:0}}>
          <ListItem>
            <ListItemButton onClick={() => toggleDrawer(anchor, true)}>
              <Grid container>
                <Grid item xs={3} paddingRight={1}>
              <ListItemText disableTypography primary="Source&nbsp;"/>
              </Grid>
              <Grid item xs={9}>
              <select className='sourceSelect' style={{width:'100%'}} value={source} onChange={(e) => onChangeGetSourcetype(e, anchor)}>
                <option value='allsource'>All Source</option>
                {
                  output.map((data, ind) => {
                    return (
                      <option value={data} key={ind} >
                        {data}
                      </option>
                    )
                  })
                }
              </select>
              </Grid>
              </Grid>
            </ListItemButton>
          </ListItem>
     {/*      <ListItem>
            <ListItemButton>
              <Grid container alignItems="baseline" display="flex">
                <Grid item xs={3} textAlign="right" paddingRight={1}>
              <span>Domains:</span>
              </Grid>
              <Grid item xs={9}>
              <div style={{width:'230px'}}>
              <MultiSelectCmSearchSuggestions value={domainName} options={filterDomainsForComponent2(userState.cmTopics)} onChangeFunc={onChangeDomain} isMulti={true} />
              </div>
              </Grid>
              </Grid>
            </ListItemButton>
          </ListItem> */}
          <ListItem>
            <ListItemButton>
              <Grid container gap={7}>
                <Grid xs={4}>
                {/* <Checkbox disableRipple sx={{paddingLeft:0}} size='small' checked={fromChecked} onChange={(e)=>onChangeCheckBoxLastUpdatedFrom(e)} /> */}
                <label>Date From&nbsp;</label>
                <input style={{minHeight:'30px',border:'1px solid lightgrey',borderRadius:'4px',fontSize:'14px',width:'138px'}} max={minDate} value={getFromDate} onChange={(e) => onChangeFromDate(e)} placeholder='Last Updated From' type="date"></input> 
              </Grid>
              <Grid item xs={4}>
                <label>Date To&nbsp;</label>
                <input style={{minHeight:'30px',border:'1px solid lightgrey',borderRadius:'4px',fontSize:'14px',width:'138px'}} max={minDate} min={getFromDate} value={getTillDate} onChange={(e) => onChangeTillDate(e)}  type="date"></input>
              </Grid>
              </Grid>
            </ListItemButton>
          </ListItem>
          {/* <ListItem>
            <ListItemButton>
              <Grid container>
                <Grid item xs={4.2} paddingRight={1}>
              <div style={{textAlign:'right'}}>
                <Checkbox disableRipple sx={{paddingLeft:0}} size='small' checked={toChecked} onChange={(e) => onChangeCheckBoxLastUpdatedTill(e)} />
                <label>Last Updated Till</label>
              </div>
              </Grid>
              <Grid item xs={5}>
            </Grid>
            </Grid>
            </ListItemButton>
          </ListItem> */}
          <ListItem sx={{paddingTop:1,paddingBottom:1}}>
            <ListItemButton sx={{cursor:'default',paddingTop:0,paddingBottom:0}}>
              <Grid container display="flex" alignItems="center">
                <Grid item xs={1} textAlign="right">
            <Checkbox disableRipple size='small' sx={{paddingLeft:0}} checked={isAccepted} onChange={(e) => onChangeAccepted(e)} />
              </Grid>
              <Grid item xs={5}>
              <label>Likes</label>
              </Grid>
              </Grid>
            </ListItemButton>
          </ListItem>
          <ListItem sx={{paddingTop:1,paddingBottom:1}}>
            <ListItemButton sx={{cursor:'default',paddingTop:0,paddingBottom:0}}>
              <Grid container display="flex" alignItems="center">
                <Grid item xs={1} textAlign="right">
            <Checkbox disableRipple size='small' sx={{paddingLeft:0}} checked={getDislikes} onChange={(e) => onChangeDislikes(e)} />
              </Grid>
              <Grid item xs={5}>
              <label>Dislikes</label>
              </Grid>
              </Grid>
            </ListItemButton>
          </ListItem>
          <ListItem sx={{paddingTop:1,paddingBottom:1}}>
            <ListItemButton sx={{cursor:'default',paddingTop:0,paddingBottom:0}}>
              <Grid container display="flex" alignItems="center">
                <Grid item xs={1} textAlign="right">
            <Checkbox disableRipple size='small' sx={{paddingLeft:0}} checked={genAIAnswer} onChange={(e) => onChangeGenAIAnswer(e)} />
              </Grid>
              <Grid item xs={5}>
              <label>GenAI Answer</label>
              </Grid>
              </Grid>
            </ListItemButton>
          </ListItem>
          <ListItem sx={{paddingTop:1,paddingBottom:1}}>
            <ListItemButton sx={{cursor:'default',paddingTop:0,paddingBottom:0}}>
              <Grid container display="flex" alignItems="center">
                <Grid item xs={1} textAlign="right">
            <Checkbox disableRipple size='small' sx={{paddingLeft:0}} checked={getBestResults} onChange={(e) =>onChangeBestResults(e)} />
              </Grid>
              <Grid item xs={5}>
              <label>Best Results</label>
              </Grid>
              </Grid>
            </ListItemButton>
          </ListItem>
          <ListItem sx={{paddingTop:1,paddingBottom:1}}>
            <ListItemButton sx={{cursor:'default',paddingTop:0,paddingBottom:0}}>
              <Grid container display="flex" alignItems="center">
                <Grid item xs={1} textAlign="right">
                  <Checkbox disableRipple size='small' sx={{paddingLeft:0}} checked={isExcludeEmail} onChange={(e) => onChangeExcludeMail(e)} />
                </Grid>
                <Grid item xs={5}>
                <label style={{display:'block',width:'200px'}}>Include Email Questions</label>
                </Grid>
              </Grid>
              </ListItemButton>
          </ListItem>
          <ListItem sx={{paddingTop:1,paddingBottom:1}}>
            <ListItemButton sx={{cursor:'default',paddingTop:0,paddingBottom:0}}>
              <Grid container display="flex" alignItems="center">
                <Grid item xs={1} textAlign="right">
                  <Checkbox disableRipple size='small' sx={{paddingLeft:0}} checked={getQSubmitted} onChange={(e) => onChangeQSubmitted(e)} />
                </Grid>
                <Grid item xs={5}>
                <label style={{display:'block',width:'200px'}}>Questions Submitted</label>
                </Grid>
              </Grid>
              </ListItemButton>
          </ListItem>
          {/* Include Empty Search Suggestions Filter */}
          <ListItem sx={{ paddingTop: 1, paddingBottom: 1 }}>
            <ListItemButton sx={{ cursor: 'default', paddingTop: 0, paddingBottom: 0 }}>
              <Grid container display="flex" alignItems="center">
                <Grid item xs={1} textAlign="right">
                  <Checkbox disableRipple size='small' sx={{ paddingLeft: 0 }} checked={getEmptySuggestions} onChange={(e) => onChangeEmptySuggestions(e)} />
                </Grid>
                <Grid item xs={5}>
                  <label style={{ display: 'block', width: '200px' }}>Empty Suggestions</label>
                </Grid>
              </Grid>
            </ListItemButton>
          </ListItem>
          {/* Include Empty Search Suggestions Filter */}
          <ListItem>
             <ListItemButton>
              <Grid container>
                <Grid item xs={2} paddingRight={1}>
              <label style={{margin:'5px'}}>Seekers&nbsp;</label>
              </Grid>
              {
                getUserData.length > 0  &&
                inputSeeker !== '' &&
                <div
                  style={{
                    width: "72%",
                    position: "absolute",
                    zIndex: "1000",
                    background: "#FFF",
                    top:'42px',
                    left:'79px',
                  }}
                >
                  {getUserData.map((data) => {
                    return (<div
                      className='userDataInfo' 
                      onClick={()=>onClickGetUserData(data)}
                      style={{
                      padding: "4px",
                      border: "lightgrey solid 1px",
                      borderRadius: "5px",
                      fontSize: "12px",
                      fontWeight:'300',
                      cursor:'pointer',
                      textAlign:'left'
                    }}>{data.firstName}{" "}{data.lastName}{" "}{`<${data.email}>`}</div>)
                  })
                  }
                </div>}
                <Grid item xs={10} paddingLeft={2}>
                  <div>
                 <input  value={inputSeeker} type="text" style={{fontSize:'12px',width:'100%'}} onChange={(e)=>onChangeFetchUsers(e,"Seeker")} className='form-control' placeholder='Enter Seekers name or email address'>
                </input>
                </div>
                </Grid>
                </Grid>
             </ListItemButton>
           </ListItem>
          {
            getFetchedUsers.length > 0 &&
            (
              <ListItem>
                <ListItemButton sx={{cursor:'default'}}>
                  <div>
                    {
                      getFetchedUsers.map((data) => {
                        return (
                          <div className='selectedUsersListSG' style={{ marginTop: '3px', marginBottom: '3px' }}>
                            {data.firstName}{" "}{data.lastName}{" "}{"<"}{data.email}{">"}
                              <span className='crossButton' onClick={() => onClickRemoveUsers(data.userUuid === undefined ? data.userUuidStr : data.userUuid)}>x</span>
                          </div>
                        )
                      })
                    }
                  </div>
                </ListItemButton>
              </ListItem>
            )
          }  
           <ListItem>
            <ListItemButton>
              <Grid container>
                <Grid xs={2}>
              <label style={{margin:'5px'}}><VizParagraph>Experts&nbsp;</VizParagraph></label>
              </Grid>
              {
                getUserDataExpert.length > 0 && inputExpert !== ''
                &&
                <div
                  style={{
                    width: "72%",
                    position: "absolute",
                    zIndex: "1000",
                    background: "#FFF",
                    top:'42px',
                    left:'77px',
                  }}
                >
                  {getUserDataExpert.map((data) => {
                    return (<div
                      className='userDataInfo' 
                      onClick={()=>onClickGetUserExpert(data)}
                      style={{
                      padding: "4px",
                      border: "lightgrey solid 1px",
                      borderRadius: "5px",
                      fontSize: "12px",
                      fontWeight:'300',
                      cursor:'pointer',
                      textAlign:'left'
                    }}>{data.firstName}{" "}{data.lastName}{" "}{`<${data.email}>`}</div>)
                  })
                  }
                </div>}
                <Grid xs={10} paddingLeft={2}>
              <input value={inputExpert} type="text" style={{fontSize:'12px',width:'100%'}} onChange={(e)=>onChangeFetchUsersExperts(e)} className='form-control' placeholder='Enter Experts name or email address'></input>
                </Grid>
            </Grid>
            </ListItemButton>
          </ListItem> 
          {
            getFetchedUsersExperts.length > 0 
            && (
              <ListItem>
                <ListItemButton sx={{cursor:'default'}}>
                  <div>
                    {
                      getFetchedUsersExperts.map((data) => {
                        return (
                          <div className='selectedUsersListSG' style={{ marginTop: '3px', marginBottom: '3px' }}>
                            {data.firstName}{" "}{data.lastName}{" "}{"<"}{data.email}{">"}
                            <span className='crossButton' onClick={() => onClickRemoveUsersExperts(data.userUuid === undefined ? data.userUuidStr : data.userUuid)}>x</span>
                          </div>
                        )
                      })
                    }
                  </div>
                </ListItemButton>
              </ListItem>
            )}
          <ListItem>
            <Grid container display="flex" justifyContent="flex-end">
              <Grid item xs={2}>
              </Grid>
              <Grid item xs={5}>
                <div style={{display:'flex'}}>
                <div style={{margin:'5px'}}>
              <VizButton size={3} type={"Tertiary"} onClick={onClickCancel}>
                  Cancel
                </VizButton>
                </div>
                <div style={{margin:'5px'}}>
                <VizButton onClick={onSubmitValues} size={3} type={"Primary"}>
                  Apply
                  </VizButton>
                  </div> 
                  </div>            
              </Grid>
            </Grid>
          </ListItem>
        </List>
        <Divider />
      </Box>
    </>
  );

  return (
    <div>
      {['right'].map((anchor) => (
        <React.Fragment key={anchor}>
          <Tooltip title="Filter List">
            <IconButton onClick={()=>setIsDrawerOpen(true)}>
              <FilterListIcon />
            </IconButton>
          </Tooltip>
          <Drawer
            anchor={"right"}
            open={isDrawerOpen}
            onClose={()=>setIsDrawerOpen(false)}
            PaperProps={{
              sx: { width:{xs:'45%',sm:'45%',lg:'25%',xl:'25%',md:'35%'},},
            }}
          >
            {list("top")}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}